/* -----------------------------------------------------------------------
 * <copyright company="Microsoft Corporation">
 *   Copyright (c) Microsoft Corporation.  All rights reserved.
 * </copyright>
 * ----------------------------------------------------------------------- */

import "./Header.scss";

import React from "react";

interface Props {
  displayName: boolean;
  candidateName: string;
}
export const Header: React.FC<Props> = ({ displayName, candidateName }) => {
  return (
    <div>
      <h1 className="ms-ac-referenceview-header" data-test-id="headerTest">
        Reference letter {displayName ? "for " + candidateName : ""}
      </h1>
    </div>
  );
};
